import { BrandLogo } from "@/components/ui/brand-logo"
import { t } from "@/lib/i18n"

import type { LandingLinks } from "./types"

export function LandingFooter({ links }: { links: LandingLinks }) {
  return (
    <footer className="border-t">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 py-8 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5">
          <BrandLogo variant="wordmark" className="h-4 text-brand-solid" />
          <span className="text-sm text-muted-foreground">{t("ui.landing.footer.tagline")}</span>
        </div>
        <div className="flex flex-wrap gap-4 text-sm font-medium">
          <a className="inline-flex min-h-11 items-center transition-colors hover:text-muted-foreground md:min-h-0" href={links.staffSignIn}>
            {t("ui.landing.footer.staff")}
          </a>
          <a className="inline-flex min-h-11 items-center transition-colors hover:text-muted-foreground md:min-h-0" href={links.userSignIn}>
            {t("ui.landing.footer.diners")}
          </a>
          <a className="inline-flex min-h-11 items-center transition-colors hover:text-muted-foreground md:min-h-0" href={links.directory}>
            {t("ui.landing.footer.directory")}
          </a>
        </div>
      </div>
    </footer>
  )
}
